import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Alert,
  Card,
} from "react-bootstrap";
import "../RolEmpleado/RecargaSaldo/RecargaSaldo.css";
import QRCode from "react-qr-code";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { BsQrCode } from "react-icons/bs";
const qrButtonStyles = `
  .qr-selector {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 8px;
  }
  .qr-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 14px;
    border-radius: 20px;
    border: 1.5px solid #dee2e6;
    background: #fff;
    font-size: 13px;
    font-weight: 500;
    color: #495057;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s, color 0.15s, box-shadow 0.15s;
    white-space: nowrap;
  }
  .qr-btn:hover {
    border-color: #0d6efd;
    color: #0d6efd;
    background: #f0f5ff;
  }
  .qr-btn.active {
    border-color: #0d6efd;
    background: #0d6efd;
    color: #fff;
    box-shadow: 0 2px 8px rgba(13,110,253,0.25);
  }
  .qr-btn .qr-btn-check {
    display: none;
  }
  .qr-btn.active .qr-btn-check {
    display: inline-flex;
  }
`;

function GenerarQREstatico() {
  const [monto, setMonto] = useState("");
  const [error, setError] = useState("");
  const [montoError, setMontoError] = useState("");
  const [showQrModal, setShowQrModal] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [rawQr, setRawQr] = useState(null);

  const [qrList, setQrList] = useState([]);
  const [qrSeleccionado, setQrSeleccionado] = useState(null);
  const [loadingList , setLoadingList] = useState(false);
  const idQr = useRef(null);
  const fetchListQR = async () => {
    try {
      setLoadingList(true)
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/public/v2/QR/Onn`,
        {
          headers: {
            "SERVICIOS-URBANOS-TOKEN": localStorage.getItem("token"),
          },
        }
      );
      if (response.data?.ok) {
        setQrList(response.data.data || []);
        setLoadingList(false)
      }
      setLoadingList(false)
    } catch (error) {
      setLoadingList(false)
      setError("Error al obtener los QRs");
    }
  };

  useEffect(() => {
    fetchListQR();
  }, []);

  const handleGenerarQR = async () => {
    if (!qrSeleccionado) {
      setError("Debes seleccionar un QR");
      return;
    }

    if (!monto || Number(monto) <= 0) {
      setMontoError("Ingrese un monto válido");
      return;
    }

    setIsSearching(true);
    setError("");
    setMontoError("");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL_QR}QR`,
        {
          idBox: qrSeleccionado,
          total: Number(monto).toFixed(2),
        },
        {
          headers: {
            "SERVICIOS-URBANOS-TOKEN": localStorage.getItem("token"),
            page: 1,
          },
        }
      );

      if (response.data.ok) {
       
        setRawQr(response.data.qr)
        setShowQrModal(true)
        idQr.current= response.data.idQr
        setError("");
      } else {
        setError(response.data.msg);
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        setError(error.response.data.msg);
      } else {
        setError("Error al generar el QR. Inténtalo de nuevo.");
      }
    } finally {
      setIsSearching(false);
    }
  };

  const handleNuevoQR = () => {
    setRawQr(null);
    setMonto("");
    setShowQrModal(false);
  };



  const wsRef = useRef(null);

  const pagoFinalizadoRef = useRef(false);
  const reconnectTimeoutRef = useRef(null);

  const connectWS = () => {
    if (pagoFinalizadoRef.current) return;
    console.log("Conectando al WebSocket...");

    wsRef.current = new WebSocket(process.env.REACT_APP_URL_WS);

    wsRef.current.onopen = () => {
      wsRef.current.send(
        JSON.stringify({
          type: "AUTH",
          token: localStorage.getItem("token"),
        })
      );
    };

    wsRef.current.onmessage = (event) => {
      let data;

      try {
        data = JSON.parse(event.data);
        if (typeof data === "string") data = JSON.parse(data);
      } catch {
        return;
      }

      if (data.msg === "Autenticado" && data.status === 200) {
        wsRef.current.send(
          JSON.stringify({
            type: "PAGO QR",
            idQR: idQr.current,
            token: localStorage.getItem("token"),
          })
        );
      }

      if (data.type === "PAGO FINALIZADO" && data.ok === true) {
        pagoFinalizadoRef.current = true;
        idQr.current = null;
        setShowQrModal(false);
        setMonto("");
        Swal.fire({
          icon: "success",
          title: "Pago exitoso",
          text: "El pago se realizó correctamente.",
        });

        wsRef.current?.close();
      }
      if (data.type === "PAGO FINALIZADO" && data.ok === false) {
        pagoFinalizadoRef.current = true;
        idQr.current = null;
        setShowQrModal(false);
        setMonto("");
        Swal.fire({
          icon: "error",
          title: "Error en el pago",
          text: data.msg || "Hubo un error al procesar el pago.",
        });

        wsRef.current?.close();
      }
    };

    wsRef.current.onclose = () => {
      wsRef.current = null;
      if (showQrModal && !pagoFinalizadoRef.current) {
        reconnectTimeoutRef.current = setTimeout(() => {
          connectWS();
        }, 3000);
      }
    };

    wsRef.current.onerror = () => {
      wsRef.current?.close();
    };
  };

  useEffect(() => {
    if (!showQrModal || !rawQr) return;

    pagoFinalizadoRef.current = false;

    connectWS();

    return () => {
      clearTimeout(reconnectTimeoutRef.current);
      wsRef.current?.close();
      wsRef.current = null;
    };
  }, [showQrModal, rawQr]);

  useEffect(() => {
    const handleOnline = () => {
      console.log("se perdio el internet, reconectando al ws...");
      if (showQrModal && !pagoFinalizadoRef.current) {
        connectWS();
      }
    };

    window.addEventListener("online", handleOnline);
    return () => window.removeEventListener("online", handleOnline);
  }, [showQrModal]);

  return (
    <Container className="recarga-container">
      <style>{qrButtonStyles}</style>
      <Card className="recarga-card">
        <Row className="justify-content-md-center">
          <Col md="12">
            <h2 className="recarga-header">Generar QR estatico</h2>
            {error && <Alert variant="danger">{error}</Alert>}
            {montoError && <Alert variant="danger">{montoError}</Alert>}

            <Form.Group>
              <Form.Label>Seleccionar QR</Form.Label>
              <div className="qr-selector">
              { loadingList && qrList.length === 0 && (
                  <span style={{ fontSize: 13, color: "#aaa" }}>
                  cargando...
                  </span>
                )}
                {!loadingList && qrList.length === 0 && (
                  <span style={{ fontSize: 13, color: "#aaa" }}>
                   Sin qr disponible
                  </span>
                )}
              {!loadingList && qrList.map((qr) => (
                  <button
                    key={qr._id}
                    type="button"
                    className={`qr-btn ${
                      qrSeleccionado === qr._id ? "active" : ""
                    }`}
                    onClick={() => {
                      setQrSeleccionado(qr._id);
                      setError("");
                    }}
                  >
                    <span
                      style={{ display: "flex", alignItems: "center", gap: 6 }}
                    >
                      <BsQrCode size={14} />
                      {qr.descripcion}
                    </span>
                  </button>
                ))}
              </div>
            </Form.Group>

            <Form>
              <Form.Group controlId="formCuitPasajero">
                <Form.Label style={{ marginTop: "10px" }}>
                  Ingrese el monto
                </Form.Label>
                <Form.Control
                  type="number"
                  value={monto}
                  onChange={(e) => setMonto(e.target.value)}
                />
              </Form.Group>
              <Button
                variant="primary"
                onClick={handleGenerarQR}
                className="recarga-button-confirm"
                disabled={isSearching}
              >
                {isSearching ? "Generando..." : "Generar QR"}
              </Button>
            </Form>

            <Modal
              show={showQrModal}
              onHide={() => setShowQrModal(false)}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Escaneá el QR</Modal.Title>
              </Modal.Header>
              <Modal.Body className="text-center">
                {rawQr && (
                  <div style={{ background: "white", padding: 16 }}>
                    <QRCode value={rawQr} size={350} />
                  </div>
                )}
                <p style={{ marginTop: 12 }}>
                  Total: <strong>${monto ? monto : 0}</strong>
                </p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowQrModal(false)}
                >
                  Cerrar
                </Button>
                <Button variant="primary" onClick={() => handleNuevoQR()}>
                  Generar nuevo monto
                </Button>
              </Modal.Footer>
            </Modal>
          </Col>
        </Row>
      </Card>
    </Container>
  );
}

export default GenerarQREstatico;
